type UploadImageResponse = {
  data?: {
    coverUrls?: { original?: string }
    url?: string
    image?: { url?: string }
  }
  url?: string
}

export function mapUploadImageUrl(res: unknown): string {
  const r = res as UploadImageResponse

  const url =
    r?.data?.coverUrls?.original ??
    r?.data?.url ??
    r?.data?.image?.url ??
    r?.url ??
    ''

  if (typeof url !== 'string' || url.trim().length === 0) {
    throw new Error('上传成功但响应中未找到有效的 image url')
  }

  return url.trim()
}
